import { getProfile } from "services/Website/UserService";
import { authenticate } from "store/Auth/actions";

export const EditIcon = ({ editFunction = () => {} }) => {
	return (
		<svg
			width="34"
			height="42"
			onClick={editFunction}
			viewBox="0 0 34 42"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<mask id="path-1-inside-1_1_1371" fill="white">
				<path d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V32C34 37.5228 29.5228 42 24 42H10C4.47715 42 0 37.5228 0 32V10Z" />
			</mask>
			<path
				d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V32C34 37.5228 29.5228 42 24 42H10C4.47715 42 0 37.5228 0 32V10Z"
				fill="#00D1FF"
				fillOpacity="0.1"
			/>
			<path
				d="M10 0V1H24V0V-1H10V0ZM34 10H33V32H34H35V10H34ZM24 42V41H10V42V43H24V42ZM0 32H1V10H0H-1V32H0ZM10 42V41C5.02944 41 1 36.9706 1 32H0H-1C-1 38.0751 3.92487 43 10 43V42ZM34 32H33C33 36.9706 28.9706 41 24 41V42V43C30.0751 43 35 38.0751 35 32H34ZM24 0V1C28.9706 1 33 5.02944 33 10H34H35C35 3.92487 30.0751 -1 24 -1V0ZM10 0V-1C3.92487 -1 -1 3.92487 -1 10H0H1C1 5.02944 5.02944 1 10 1V0Z"
				fill="#00D1FF"
				fillOpacity="0.3"
				mask="url(#path-1-inside-1_1_1371)"
			/>
			<path
				d="M17 15H12.3333C11.9797 15 11.6406 15.1405 11.3905 15.3905C11.1405 15.6406 11 15.9797 11 16.3333V25.6667C11 26.0203 11.1405 26.3594 11.3905 26.6095C11.6406 26.8595 11.9797 27 12.3333 27H21.6667C22.0203 27 22.3594 26.8595 22.6095 26.6095C22.8595 26.3594 23 26.0203 23 25.6667V21"
				stroke="#00D1FF"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.2499 14.75C21.5151 14.4848 21.8748 14.3358 22.2499 14.3358C22.625 14.3358 22.9847 14.4848 23.2499 14.75C23.5151 15.0152 23.6641 15.3749 23.6641 15.75C23.6641 16.1251 23.5151 16.4848 23.2499 16.75L17.2412 22.7593C17.0829 22.9175 16.8874 23.0333 16.6726 23.096L14.7572 23.656C14.6999 23.6727 14.6391 23.6737 14.5812 23.6589C14.5233 23.6441 14.4705 23.614 14.4282 23.5717C14.3859 23.5294 14.3558 23.4766 14.341 23.4187C14.3262 23.3608 14.3272 23.3 14.3439 23.2427L14.9039 21.3273C14.9669 21.1127 15.0829 20.9174 15.2412 20.7593L21.2499 14.75Z"
				stroke="#00D1FF"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
export const DeleteIcon = ({ deleteFunction = () => {} }) => {
	return (
		<svg
			width="34"
			height="42"
			onClick={deleteFunction}
			className="cursor-pointer"
			viewBox="0 0 34 42"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<mask id="path-1-inside-1_1_2635" fill="white">
				<path d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V32C34 37.5228 29.5228 42 24 42H10C4.47715 42 0 37.5228 0 32V10Z" />
			</mask>
			<path
				d="M0 10C0 4.47715 4.47715 0 10 0H24C29.5228 0 34 4.47715 34 10V32C34 37.5228 29.5228 42 24 42H10C4.47715 42 0 37.5228 0 32V10Z"
				fill="#FB2C36"
				fillOpacity="0.1"
			/>
			<path
				d="M10 0V1H24V0V-1H10V0ZM34 10H33V32H34H35V10H34ZM24 42V41H10V42V43H24V42ZM0 32H1V10H0H-1V32H0ZM10 42V41C5.02944 41 1 36.9706 1 32H0H-1C-1 38.0751 3.92487 43 10 43V42ZM34 32H33C33 36.9706 28.9706 41 24 41V42V43C30.0751 43 35 38.0751 35 32H34ZM24 0V1C28.9706 1 33 5.02944 33 10H34H35C35 3.92487 30.0751 -1 24 -1V0ZM10 0V-1C3.92487 -1 -1 3.92487 -1 10H0H1C1 5.02944 5.02944 1 10 1V0Z"
				fill="#FB2C36"
				fillOpacity="0.3"
				mask="url(#path-1-inside-1_1_2635)"
			/>
			<path
				d="M11 17H23"
				stroke="#FF6467"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.6663 17V26.3333C21.6663 27 20.9997 27.6667 20.333 27.6667H13.6663C12.9997 27.6667 12.333 27 12.333 26.3333V17"
				stroke="#FF6467"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.333 17V15.6667C14.333 15 14.9997 14.3334 15.6663 14.3334H18.333C18.9997 14.3334 19.6663 15 19.6663 15.6667V17"
				stroke="#FF6467"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.667 20.3334V24.3334"
				stroke="#FF6467"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.333 20.3334V24.3334"
				stroke="#FF6467"
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
export const CloseIcon = ({ toggle = () => {} }) => {
	return (
		<svg
			onClick={toggle}
			width="40"
			className="cursor-pointer"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<mask id="path-1-inside-1_1_2265" fill="white">
				<path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" />
			</mask>
			<path
				d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
				fill="#0B0F14"
				fillOpacity="0.5"
			/>
			<path
				d="M0 20M40 20M40 20M0 20M20 0M40 20M20 40M0 20M20 40V39C9.50659 39 1 30.4934 1 20H0H-1C-1 31.598 8.40202 41 20 41V40ZM40 20H39C39 30.4934 30.4934 39 20 39V40V41C31.598 41 41 31.598 41 20H40ZM20 0V1C30.4934 1 39 9.50659 39 20H40H41C41 8.40202 31.598 -1 20 -1V0ZM20 0V-1C8.40202 -1 -1 8.40202 -1 20H0H1C1 9.50659 9.50659 1 20 1V0Z"
				fill="#00D1FF"
				fillOpacity="0.3"
				mask="url(#path-1-inside-1_1_2265)"
			/>
			<path
				d="M15.875 15.8752L24.1246 24.1248"
				stroke="#99A1AF"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M24.125 15.8752L15.8754 24.1248"
				stroke="#99A1AF"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
export const getAuthData = (dispatch) => {
	const token = localStorage.getItem("vr_token");
	const auth = localStorage.getItem("vr_auth");
	const authParsed = JSON.parse(auth);
	if (token && authParsed) {
		dispatch(authenticate({ ...authParsed, accessToken: token }));

		if (authParsed?.userType === "user") {
			getProfile().then((res) => {
				if (res?.status === 200) {
					const profile = res.data?.data ?? {};
					const newBalance = profile.wallet_total_amount;
					if (newBalance !== undefined) {
						const stored = JSON.parse(localStorage.getItem("vr_auth") || "{}");
						localStorage.setItem(
							"vr_auth",
							JSON.stringify({ ...stored, wallet_total_amount: newBalance }),
						);
						dispatch(
							authenticate({
								...authParsed,
								accessToken: token,
								wallet_total_amount: newBalance,
							}),
						);
					}
				}
			});
		}
	}
};
